import AcquirerStoreEditForm from "./AcquirerStoreEditForm";
import AcquirerStoreForm from "./AcquirerStoreForm";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";

import {
  CircularProgress,
  Typography,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Paper,
  Box,
  makeStyles,
  styled,
  Grid,
  DialogContentText,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from "@material-ui/core";

import {
  pageAcquirerStoreDto,
  searchAcquirerStoreDto,
} from "../../service/AcquirerStoreRequest";

import { AcquirerStoreAddButtonControl } from "./style/AcquirerStoreStyle";
import { use } from "react";



const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));
 

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: theme.spacing(3),
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing(1),
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  selectType:{
    width:'100%',
    textAlign:'center',
    
  }
}));
export default function AcquirerStoreTable() {
  const classes = useStyles();
  const [page, setPage] = useState(1);
  const [data, setData] = useState([["Loading Data..."]]);
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortOrder, setSortOrder] = useState(0);
  const [open, setOpen] = useState(false);

  const [addOpen, setAddOpen] = useState(false);
  const [editAcquirerStoreDto, setEditAcquirerStoreDto] = useState({});

  const [refreshFlag, setRefreshFlag] = useState(false);

  const [searchName, setSearchName] = useState("");

  const [searchRefreshFlag, setSearchRefreshFlag] = useState(false);

  const [businessName,setBusinessName] = useState();
  const [storeName,setStoreName]=useState();
  const [id,setId]=useState();
  const [acquirerTypeOpen,setAcquirerTypeOpen]=useState(false);
  
  const [acquirerType,setAcquirerType] = useState();


  const [settlementMethodOpen,setSettlementMethodOpen]=useState(false);
  
  const [settlementMethod,setSettlementMethod] = useState();

  const searchAcquirerStore = () => {
    
    let acquirerStoreVo = {
      index:page,
      pageSize:10,
      businessNameLike:businessName,
      storeNameLike:storeName,
      id:id,
      acquirerType:acquirerType,
      settlementMethod:settlementMethod,
    }
    initData(acquirerStoreVo);
    
    //setSearchRefreshFlag(true);
  };

  const handleAcquirerTypeClose =()=>{
    setAcquirerTypeOpen(false);
  } 

  const handleAcquirerTypeOpen =()=>{
    setAcquirerTypeOpen(true);
  }

  const handleAcquirerTypeChange= (event)=>{
    setAcquirerType(event.target.value);
  }


  const settlementMethodClose =()=>{
    setSettlementMethodOpen(false);
  } 

  const handleSettlementMethodOpen =()=>{
    setSettlementMethodOpen(true);
  }

  const handleSettlementMethodChange= (event)=>{
    setSettlementMethod(event.target.value);
  }
  const addAcquirerStore = () => {
    console.log("======handle add addAcquirerStore");
    setAddOpen(!addOpen);
  };

  const resetAcquirerStore = () => {
     
     setId();
     setBusinessName();
     setStoreName();
     setAcquirerType();
     setSettlementMethod();
  };
  const handleClose = () => {
    console.log("======handle close");
    setOpen(!open);
  };

  const handleEditSubmit = () => {
    console.log("======handle edit submit");
    setOpen(!open);
    

    setTimeout(() => {
      setRefreshFlag(true);
    }, 10);
  };

  const handleSubmit = () => {
    
    console.log("==handleSubmit=");

    setAddOpen(!addOpen);

    setRefreshFlag(true);
  };

  const handleAddClose = () => {
    debugger;
    console.log("======handle add close");
    setAddOpen(!addOpen);
    setTimeout(() => {
      setRefreshFlag(true);
    }, 1000);
  };

  const changePage = (page, sortOrder) => {
    setIsLoading(true);
    console.log("===page", page);
    page = page + 1;
    let acquirerStoreVo = {
      index:page,
      pageSize:10,
      businessNameLike:businessName,
      storeNameLike:storeName,
      id:id,
      acquirerType:acquirerType,
      settlementMethod:settlementMethod,
    };
    initData(acquirerStoreVo);
  };

  const editAcquirerStoreData = (tableMeta) => {
 
    const row = tableMeta.rowIndex;
    console.log("row", row);
    setOpen(!open);
    const editAcquirerStoreDto = data[row];
    setEditAcquirerStoreDto(editAcquirerStoreDto);
  };
  console.log("count===", count);
  const options = {
    filterType: "dropdown",
    responsive: "vertical",
    serverSide: true,
    count: count,
    rowsPerPage: 10,
    rowsPerPageOptions: [],
    sortOrder: { sortOrder },
    print: false,
    download: false,
    filter: false,
    viewColumns: false,
    onTableChange: (action, tableState) => {
      console.log(action, tableState);

      // a developer could react to change on an action basis or
      // examine the state as a whole and do whatever they want

      switch (action) {
        case "changePage":
          changePage(tableState.page, tableState.sortOrder);
          break;
        case "sort":
          this.sort(tableState.page, tableState.sortOrder);
          break;
        default:
          console.log("action not handled.");
      }
    },
  };

  const initData = async (acquirerStoreVo) => {

    try{
      setIsLoading(true);
  
      
      let response =await pageAcquirerStoreDto(acquirerStoreVo);
  
       
      if (response && response.data) {
        setData(response.data.records);
        setCount(response.data.total);
      }
  
      setIsLoading(false);
      setPage(acquirerStoreVo.index);
    }catch(e){
      console.log("initData==error=={}",e)
    }
   
     
  };


  const addOpenMethod = () => {
     
      setAddOpen(!addOpen);
 };
  const searchAcquirerStoreData = (index, pageSize, searchName) => {
    setIsLoading(true);
   
    searchAcquirerStoreDto(index, pageSize, searchName).then((res) => {
      // const albums = res.albums;
      console.log("====data", res.data);

      setData(res.data.records);
      setIsLoading(false);
      setCount(res.data.total);
      setPage(index);
    });
    setIsLoading(false);
  };
  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    // Update the document title using the browser API
    let acquirerStoreVo = {
      index: 1,
      pageSize: 10,
    };
    initData(acquirerStoreVo);
    setRefreshFlag(false);
  }, [refreshFlag]);

  useEffect(() => {
   
    console.log("===searchAcquirerStoreData=");
    if (searchRefreshFlag) {
      console.log("searchName===", searchName);
    }

    if (!searchName) return;
    searchAcquirerStoreData(page, 10, searchName);

    setSearchRefreshFlag(false);
  }, [searchRefreshFlag]);

  const configurationData = {
    page: 0,
    count: 1,
    rowsPerPage: 10,
    sortOrder: {},
    data: [["Loading Data..."]],
    columns: [
      {
        name: "id",
        label: "id",
        options: {
          customBodyRender: (value, tableMeta, updateValue) => {
            // Here you can render a more complex display.
            // You're given access to tableMeta, which has
            // the rowData (as well as the original object data).
            // See the console for a detailed look at this object.

            if (value) {
              return value.toString();
            }
            return value;
          },
        },
      },
      {
        name: "businessName",
        label: "Company Name",
        options: {},
      },
      {
        name: "storeName",
        label: "Store Name",
        options: {
          customBodyRender: (value, tableMeta, updateValue) => {
            // Here you can render a more complex display.
            // You're given access to tableMeta, which has
            // the rowData (as well as the original object data).
            // See the console for a detailed look at this object.

            if (value) {
              return value.toString();
            }
            return value;
          },
        },
      },
      {
        name: "acquirerType",
        label: "Acquirer Type",
        options: {},
      },

      {
        name: "rate",
        label: "MDR",
        options: {
          customBodyRender: (value, tableMeta, updateValue) => {
            // Here you can render a more complex display.
            // You're given access to tableMeta, which has
            // the rowData (as well as the original object data).
            // See the console for a detailed look at this object.

            if (value) {
              return value.toString();
            }
            return value;
          },
        },
      },
      {
        name: "storeCurrency",
        label: "Store Currency",
        options: {},
      },
      
      {
        name: "settlementMethod",
        label: "Settlement Method",
        options: {},
      },
      
     
      {
        name: "creationTime",
        label: "Create Time",
        options: {},
      },
      {
        name: "Action",
        options: {
          filter: true,
          sort: false,
          empty: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <Box>
                <Button
                  variant="outlined"
                  size="small"
                  color="primary"
                  onClick={(e) => editAcquirerStoreData(tableMeta)}
                >
                  Edit
                </Button>
              </Box>
            );
          },
        },
      },
    ],
  };

  return (
    <div>
      <Box  component="form"   autoComplete="off"  sx={{
                     '& .MuiTextField-root': { m: 1, width: '25ch' },
                   }}   >
                   
                   <Grid container spacing={3}>
                        <Grid item xs={4}>
                          <Paper className={classes.paper}>
                          <TextField id="id" label="Id"  value={id}   onChange={(event) => {
                              setId(event.target.value);
                            }}  />
                        </Paper>
                        </Grid>

                       

                        <Grid item xs={4}>
                          <Paper className={classes.paper}>
                          <TextField id="companyName" label="Company Name"  value={businessName}   onChange={(event) => {
                              setBusinessName(event.target.value);
                            }}  />
                        </Paper>
                        </Grid>

                        <Grid item xs={4}>
                          <Paper className={classes.paper}>
                          <TextField id="storeName" label="Store Name"  value={storeName}   onChange={(event) => {
                              setStoreName(event.target.value);
                            }}  />
                        </Paper>
                        </Grid>

                        <Grid item xs={4}>
                          <Paper className={classes.selectType}>
                        

                             <FormControl className={classes.selectType}>
                                      <InputLabel id="acquirerType">AcquirerType</InputLabel>
                                      <Select
                                      labelId="acquirerType"
                                      id="acquirerType-select"
                                      open={acquirerTypeOpen}
                                      onClose={handleAcquirerTypeClose}
                                      onOpen={handleAcquirerTypeOpen}
                                      value={acquirerType}
                                      onChange={handleAcquirerTypeChange}
                                      >
                                      <MenuItem value="">
                                          <em>None</em>
                                      </MenuItem>  
                                      <MenuItem value="GRAB_MERCHANT_PRESENTED_QR_GRAB_PAY">Grab</MenuItem>
                                      <MenuItem value="GRAB_MERCHANT_PRESENTED_QR_PAY_LATER">GrabLater</MenuItem>
                                      <MenuItem value="ALI_MERCHANT_SCAN_USER_QR_PAY">Alipay</MenuItem>
                                      <MenuItem value="ALI_STATIC_QR_CODE">AlipayStatic</MenuItem>
                                      
                                      <MenuItem value="WECHAT_MERCHANT_SCAN_USER_QR_PAY">Wechat</MenuItem>
                                      <MenuItem value="MINI_PROGRAM_WECHAT_MERCHANT_PAY">WechatMiniProgram</MenuItem>

                                      <MenuItem value="WECHAT_IN_APP_MERCHANT_PAY">WechatInApp</MenuItem>
                                      <MenuItem value="WECHAT_NATIVE_MERCHANT_PAY">WechatNative</MenuItem>

                                      <MenuItem value="WECHAT_H5_MERCHANT_PAY">WechatH5</MenuItem>
                                      <MenuItem value="WECHAT_JSAPI_MERCHANT_PAY">WechatJsapi</MenuItem>


                                      <MenuItem value="DBS_PAY_NOW_MERCHANT_PRESENTED_QR_PAY">DbsPayNow</MenuItem>

                                      <MenuItem value="CHECK_OUT_PAY">Checkout</MenuItem>
                                      <MenuItem value="DCS_CARD_NOW_PAY">DCSCardNow</MenuItem>
                                      <MenuItem value="SOLANA_PAY">solanaPay</MenuItem>
                                      </Select>
                                  </FormControl>
                        </Paper>
                        </Grid>

                        <Grid item xs={4}>
                      
                        <Paper className={classes.selectType}>
                        <FormControl className={classes.selectType}>
                                 <InputLabel id="settlementMethod"  >Settlement Method</InputLabel>
                                 <Select
                                 labelId="settlementMethod"
                                 id="settlementMethod-select"
                                 open={settlementMethodOpen}
                                 onClose={settlementMethodClose}
                                 onOpen={handleSettlementMethodOpen}
                                 value={settlementMethod}
                                 onChange={handleSettlementMethodChange}
                                 >
                                 <MenuItem value="">
                                     <em>None</em>
                                 </MenuItem>  
                                 <MenuItem value="t_plus_one">T+1</MenuItem>
                                 <MenuItem value="t_plus_two">T+2</MenuItem>
                                 <MenuItem value="t_plus_three">T+3</MenuItem>
                                 <MenuItem value="t_plus_week">T+7</MenuItem>
                                 
                                

                                 
                                 </Select>
                             </FormControl>
                             </Paper>
                        </Grid>

                        <Grid item xs={4}>
                          <Paper className={classes.paper}><Button onClick={searchAcquirerStore}  variant={"outlined"} color="primary">Search</Button></Paper>
                          </Grid>
                          <Grid item xs={4}>
                          <Paper className={classes.paper}><Button onClick={resetAcquirerStore}  type="reset" variant={"outlined"} color="primary">Reset</Button></Paper>
                        </Grid>
                        <Grid item xs={4}>
                          <Paper className={classes.paper}><Button onClick={addOpenMethod}  type="reset" variant={"outlined"} color="primary">Add</Button></Paper>
                        </Grid>
                    </Grid>
                        
        </Box>
      

      <MUIDataTable
        title={
          <Typography variant="h6">
            AcquirerStore list
            {isLoading && (
              <CircularProgress
                size={24}
                style={{ marginLeft: 15, position: "relative", top: 4 }}
              />
            )}
          </Typography>
        }
        data={data}
        columns={configurationData.columns}
        options={options}
      />

      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            width: "100%",
            height: "50%",
          },
        }}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle>Edit AcquirerStore</DialogTitle>
        <DialogContent>
          <AcquirerStoreEditForm
            handleEditClose={handleClose}
            handleEditSubmit={handleEditSubmit}
            editAcquirerStoreDto={editAcquirerStoreDto}
          />
        </DialogContent>
      </Dialog>

      <Dialog open={addOpen} onClose={handleAddClose} fullWidth maxWidth="lg">
        <DialogTitle>Add AcquirerStore</DialogTitle>
        <DialogContent>
          <AcquirerStoreForm
              handleSubmit={handleSubmit}
              handleAddClose={handleAddClose}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>


       <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            width: "100%",
            height: "50%",
          },
        }}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle>Edit AcquirerStore</DialogTitle>
        <DialogContent>
          <AcquirerStoreEditForm
            handleEditClose={handleClose}
            handleEditSubmit={handleEditSubmit}
            editAcquirerStoreDto={editAcquirerStoreDto}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}
